// extracted by mini-css-extract-plugin
module.exports = {"hideSmallScreen":"hN","showOnlySmallScreen":"iN","deliveryPromiseDate":"jN","estimated":"kN","deliveryPromise":"lN","condensed":"mN"};